import sectionItemsGrid06Css from '../css-snippets/section-items-grid-06';

const html = `
<style>${sectionItemsGrid06Css}</style>
<div
  id="items-grid-section-unique-id"
  data-id="unique-id"
  class="items-grid-wrapper"
  data-attribute="items-grid-wrapper"
  data-background-color="#EBEBEB"
  data-text-color="#000000"
  data-card-background-color="#FFFFFF"
  data-card-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  data-background-image="false"
  data-card-border-radius="0"
  data-item-image-width-mobile="64"
  data-item-image-width-desktop="64"
  style="
    --background-color: #EBEBEB; 
    --text-color: #000000; 
    --card-text-color: #000000; 
    --card-background-color: #FFFFFF;
    --card-border-radius: 0;
    --item-image-width-mobile: 64px;
    --item-image-width-desktop: 64px;
  "
>
  <div
    data-attribute="items-grid-content"
    class="items-grid-content container"
    data-container-full-width="false"
  >
    <div data-attribute="title-content" class="items-grid-header">
      <h2 style="text-align: center">
        <strong>Click to Learn More</strong>
      </h2>
    </div>
    <div
      data-attribute="list-item"
      class="items-grid-list"
      data-items-per-row-mobile="1"
      data-items-per-row-desktop="3"
      style="--items-per-row-mobile: 1; --items-per-row-desktop: 3"
    >
      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/04/10/image-69d86129c68290a0907eeda7.png?w=100&h=50&q=80"
            alt="img"
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <h2><strong>HEALTHY INQUIRY</strong></h2>
          <p>Health Conditions, Medications & Supplements</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/04/10/image-69d8613866181bcfce77827b.png?w=100&h=50&q=80"
            alt="img"
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <h2><strong>ORDER INQUIRY</strong></h2>
          <p>Placing an order, subscribing & related policies</p>
        </div>
      </div>

      <div data-attribute="item" class="items-grid-item">
        <div class="items-grid-item-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/04/10/image-69d8614884e2cff0bad5d58e.png?w=100&h=50&q=80"
            alt="img"
          />
        </div>
        <div data-attribute="text-item" class="items-grid-item-text">
          <h2><strong>PRODUCT INQUIRY</strong></h2>
          <p>Ingredients, Usage, Results & Certifications</p>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
